var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[_c('Banner'),_c('LeftRightSection'),_c('Info'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }